import { AiResponseSystemMessage } from '@app-velocity/ui';

import { useSingleAiResponseContext } from '../../hooks/useSingleAiResponseContext';

export const SystemResponse = () => {
  const { message } = useSingleAiResponseContext();

  if (!message) return null;

  return <AiResponseSystemMessage message={message} />;
};
